export default Object.freeze({
    text: 'text',
    search: 'search',
    number: 'number',
})
